import { catalog, selectedChannel, updateState, templates, currentUser } from './admin-globals.js';

const MOVE_CHANNEL_UI_KEY = 'raptv_admin_move_to_channel';
function isMoveChannelToolbarOn() {
  try {
    return localStorage.getItem(MOVE_CHANNEL_UI_KEY) === '1';
  } catch (_) {
    return false;
  }
}
function channelIsTopVoted(ch) {
  return !!(ch && (ch.top_voted || ch.is_top_voted));
}
import { escHtml, showToast, showConfirm } from './admin-ui-base.js';
import { authHeaders } from './admin-auth.js';

export function canEditChannel(ch) {
  if (!ch) return false;
  if (ch.can_edit === false) return false;
  if (ch.can_edit === true) return true;
  return ch.is_owner === true;
}

export function applyEditPermissions() {
  const ch = catalog[selectedChannel];
  const canEdit = canEditChannel(ch);
  const saveBtn = document.getElementById('save-btn');
  if (saveBtn) {
    saveBtn.style.display = canEdit ? '' : 'none';
    saveBtn.disabled = !canEdit;
  }
  const addChBtn = document.querySelector('.add-ch-btn');
  if (addChBtn) addChBtn.style.display = canEdit || (currentUser && currentUser.is_admin) ? '' : 'none';
}

export function renderSidebar() {
  const el = document.getElementById('sidebar-channels');
  if (!el) return;
  el.innerHTML = '';
  catalog.forEach((ch, i) => {
    const item = document.createElement('div');
    item.className = 'ch-item' + (i === selectedChannel ? ' active' : '');
    const isOwner = ch.is_owner !== false;
    const roleHint =
      ch.member_role === 'viewer'
        ? ' <span title="Solo lectura">👁</span>'
        : ch.member_role === 'editor' && !isOwner
          ? ' <span title="Editor">✎</span>'
          : '';
    item.innerHTML = `
      <div class="ch-color-dot" style="background:${ch.color}"></div>
      <div class="ch-item-info">
        <div class="ch-item-num">CH ${ch.num}${roleHint}</div>
        <div class="ch-item-name">${escHtml(ch.name)}</div>
      </div>
      <button class="ch-delete-btn" title="Exportar canal como JSON" onclick="window.exportChannel(event, ${i})" style="color:rgba(0,255,255,0.6);font-size:12px">⬇</button>
      ${isOwner ? `<button class="ch-delete-btn" title="Importar JSON al canal" onclick="window.importChannel(event, ${i})" style="color:rgba(0,255,255,0.6);font-size:12px">⬆</button>` : ''}
      ${isOwner ? `<button class="ch-delete-btn" title="Invitar colaborador" onclick="window.shareChannel(event, ${i})" style="color:rgba(212,255,0,0.6);font-size:12px">⬡</button>` : ''}
      ${isOwner ? `<button class="ch-delete-btn" title="Eliminar canal" onclick="window.deleteChannel(event, ${i})">✕</button>` : ''}
    `;
    item.addEventListener('click', () => selectChannel(i));
    el.appendChild(item);
  });
}

export function selectChannel(index) {
  updateState('selectedChannel', index);
  renderSidebar();
  renderMain();
  applyEditPermissions();
}

export function renderMain() {
  if (selectedChannel === null || !catalog[selectedChannel]) {
    const mainEl = document.getElementById('main-content');
    if (mainEl) mainEl.innerHTML = '<div class="no-channel"><div>◄ SELECCIONA UN CANAL</div></div>';
    return;
  }

  const ch = catalog[selectedChannel];
  const mainEl = document.getElementById('main-content');
  if (!mainEl) return;

  const readOnly = !canEditChannel(ch);
  const ro = readOnly ? 'disabled' : '';

  mainEl.innerHTML = `
    ${readOnly ? '<div style="margin-bottom:12px;padding:10px 14px;border:1px solid rgba(212,255,0,0.35);border-radius:6px;font-family:VT323,monospace;color:rgba(212,255,0,0.85);letter-spacing:2px">👁 SOLO LECTURA — puedes ver la parrilla, no guardar cambios</div>' : ''}
    <div class="channel-header">
      <div class="channel-fields">
        <div class="field-group">
          <div class="field-label">Nº CANAL</div>
          <input type="text" id="edit-ch-num" value="${ch.num}" style="width:70px" ${ro} onchange="window.updateChannelField('num', this.value)">
        </div>
        <div class="field-group" style="flex:1;min-width:180px">
          <div class="field-label">NOMBRE</div>
          <input type="text" id="edit-ch-name" value="${escHtml(ch.name)}" style="width:100%" ${ro} onchange="window.updateChannelField('name', this.value)">
        </div>
        <div class="field-group">
          <div class="field-label">COLOR</div>
          <input type="color" id="edit-ch-color" value="${ch.color}" ${ro} onchange="window.updateChannelField('color', this.value)">
        </div>
        
        <div class="field-group">
          <div class="field-label">SYNC</div>
          <div class="toggle-wrap" style="margin-top:6px">
            <label class="toggle">
              <input type="checkbox" ${ch.sync ? 'checked' : ''} onchange="window.updateChannelField('sync', this.checked)">
              <span class="toggle-slider"></span>
            </label>
          </div>
        </div>

        <div class="field-group">
          <div class="field-label">PLANTILLA</div>
          <select onchange="window.updateChannelField('template', this.value)" style="background:#000;color:#0f8;border:1px solid #333;padding:5px;font-family:inherit;font-size:12px;margin-top:2px;height:28px">
            ${templates.length > 0 
              ? templates.map(t => `<option value="${t}" ${ch.template === t ? 'selected' : ''}>${t}</option>`).join('')
              : `<option value="RapTV" ${ch.template === 'RapTV' ? 'selected' : ''}>RapTV (Classic)</option>`
            }
          </select>
        </div>

        <div class="field-group">
          <div class="field-label">⭐ TOP</div>
          <div class="toggle-wrap" style="margin-top:6px">
            <label class="toggle">
              <input type="checkbox" ${ch.is_top_voted ? 'checked' : ''} onchange="window.updateChannelField('is_top_voted', this.checked)">
              <span class="toggle-slider" style="background-color:rgba(212,255,0,0.2)"></span>
            </label>
          </div>
        </div>

        <div class="field-group">
          <div class="field-label">🛡️ ADMIN</div>
          <div class="toggle-wrap" style="margin-top:6px">
            <label class="toggle">
              <input type="checkbox" ${ch.is_admin_only ? 'checked' : ''} onchange="window.updateChannelField('is_admin_only', this.checked)">
              <span class="toggle-slider" style="background-color:rgba(255,0,85,0.2)"></span>
            </label>
          </div>
        </div>
        ${currentUser && currentUser.is_admin ? `
        <div class="field-group" title="Muestra el botón 📤 en cada vídeo para enviarlo a otro canal (API igual que inbox TV)">
          <div class="field-label">📤 MOVER</div>
          <div class="toggle-wrap" style="margin-top:6px">
            <label class="toggle">
              <input type="checkbox" ${isMoveChannelToolbarOn() ? 'checked' : ''} onchange="window.setMoveChannelUi(this.checked)">
              <span class="toggle-slider" style="background-color:rgba(0,255,136,0.15)"></span>
            </label>
          </div>
        </div>
        ` : ''}

        <div class="field-group" style="flex:1;min-width:220px">
          <div class="field-label">🏷 TAGS MINIO</div>
          <div style="display:flex;gap:6px;align-items:center">
            <input type="text" id="edit-ch-minio-tags" value="${escHtml(ch.minio_tags || '')}" style="flex:1" onchange="window.updateChannelField('minio_tags', this.value)">
            <button class="btn btn-secondary" style="padding:4px 10px;font-size:12px" onclick="window.syncMinioTags(document.getElementById('edit-ch-minio-tags').value)">🔄</button>
          </div>
        </div>

        <div class="field-group" style="flex:1;min-width:220px">
          <div class="field-label">🖼 FONDO</div>
          <input type="text" id="edit-ch-background" value="${escHtml(ch.background || '')}" placeholder="URL o color (ej: #110a0e)" style="width:100%" onchange="window.updateChannelField('background', this.value)">
        </div>
      </div>
    </div>

    <div class="section-heading">VÍDEOS (${ch.videos.length}) <span style="font-size:14px;color:rgba(255,255,255,0.3)">${totalDurationLabel(ch.videos)}</span></div>

    <div class="video-list" id="video-list"></div>

    ${readOnly ? '' : `<div style="display:flex;gap:10px;flex-wrap:wrap;margin-top:15px">
      <button class="btn btn-primary" onclick="window.openAddVideo()">+ AÑADIR VÍDEO</button>
      <button class="btn btn-danger" onclick="window.openYTSearch()">🔍 BUSCAR YOUTUBE</button>
      <button class="btn btn-secondary" onclick="window.openPlaylistImport()">📋 IMPORTAR PLAYLIST</button>
      <button class="btn btn-secondary" onclick="window.openLibraryModal()">📚 BIBLIOTECA</button>
      <button class="btn btn-secondary" onclick="window.openMinioModal()">📂 MINIO</button>
      <button class="btn btn-secondary" onclick="void window.fetchMissingDurations?.(false)" title="YouTube vía API servidor + MinIO local">⏱ DURACIONES</button>
      <button class="btn btn-secondary" onclick="window.shuffleVideos()">🔀 RANDOMIZAR</button>
      <button class="btn btn-danger" onclick="window.clearVideos()">🗑 VACIAR</button>
    </div>`}
  `;

  renderVideoList();
  applyEditPermissions();
}

export async function renderVideoList() {
  const ch = catalog[selectedChannel];
  const el = document.getElementById('video-list');
  if (!el || !ch) return;

  if (ch.videos.length === 0) {
    el.innerHTML = '<div class="empty-state">SIN VÍDEOS · AÑADE UNO</div>';
    return;
  }

  el.innerHTML = '';
  const showMoveToChannel =
    currentUser &&
    currentUser.is_admin &&
    isMoveChannelToolbarOn() &&
    !channelIsTopVoted(ch);
  const readOnly = !canEditChannel(ch);

  ch.videos.forEach((vid, i) => {
    const hasDur = vid.duration && vid.duration > 0;
    const row = document.createElement('div');
    row.className = 'video-row' + (vid.flagged ? ' video-row-flagged' : '');
    
    // URL or subtitle logic
    const subtitle = vid.type === 'youtube' 
      ? `https://www.youtube.com/watch?v=${vid.id}` 
      : (vid.url || vid.id);

    row.innerHTML = `
      <div class="video-index">${i + 1}</div>
      <div class="video-status-dot" style="background:${hasDur ? '#00ff88' : '#ff3366'}"></div>
      <div class="video-type-badge ${vid.type}">${vid.type === 'youtube' ? 'YT' : 'LOCAL'}</div>
      <div class="video-info">
        <div class="video-title">${escHtml(vid.title)}</div>
        <div class="video-subtitle">${escHtml(subtitle)}</div>
      </div>
      <div class="video-actions">
        ${showMoveToChannel ? `<button class="icon-btn" onclick="window.openMoveVideoToChannel(${i})" title="Mover a otro canal" style="color:#7dffb3">📤</button>` : ''}
        <button class="icon-btn" onclick="window.previewVideo(${i})" title="Previsualizar">▶</button>
        ${ch.name === '[⚠️] CUARENTENA' 
          ? `<button class="icon-btn" onclick="window.restoreFromQuarantine(${i})" title="Restaurar a otro canal" style="color:#00ff88">🏠</button>`
          : `<button class="icon-btn ${vid.flagged ? 'active' : ''}" onclick="window.toggleFlag(${i})" title="Marcar como problemático" style="color:${vid.flagged ? '#ff3366' : 'inherit'}">🚩</button>`
        }
        ${vid.flagged && ch.name !== '[⚠️] CUARENTENA' ? `<button class="icon-btn" onclick="window.moveToQuarantine(${i})" title="Mover a Cuarentena" style="color:#ff9500">☢️</button>` : ''}
        ${readOnly ? '' : `<button class="icon-btn" onclick="window.moveVideo(${i}, -1)" title="Subir">↑</button>
        <button class="icon-btn" onclick="window.moveVideo(${i}, 1)" title="Bajar">↓</button>
        <button class="icon-btn" onclick="window.openEditVideo(${i})" title="Editar">✎</button>
        <button class="icon-btn danger" onclick="window.deleteVideo(${i})" title="Eliminar">✕</button>`}
      </div>
    `;
    el.appendChild(row);
  });
}

export function totalDurationLabel(videos) {
  const total = videos.reduce((acc, v) => acc + (v.duration || 0), 0);
  if (total === 0) return '';
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = Math.round(total % 60);
  if (h > 0) return `· ${h}h ${m}m`;
  if (m > 0) return `· ${m}m ${s}s`;
  return `· ${s}s`;
}

// Global scope bridges
window.selectChannel = selectChannel;
window.renderSidebar = renderSidebar;
window.renderMain = renderMain;
window.renderVideoList = renderVideoList;